import apiClient from './apiClient';

export interface AuditResult {
  seq: number;
  docNo: string;
  tableCode: string;
  docType: string;
  docDate: string | null;
  masterAmt: number;
  recalcAmt: number;
  masterQty: number;
  recalcQty: number;
  creator: string;
  status: string;
}

export interface RunAuditRequest {
  category: 'amount_check' | 'blank_key_check' | 'warehouse_fix' | 'sc_recalc';
  dateFrom?: string;
  dateTo?: string;
  tables?: string[];
}

export interface RunAuditResponse {
  category: string;
  startedAt: string;
  completedAt: string;
  totalChecked: number;
  issuesFound: number;
  results: AuditResult[];
}

export const c901gApi = {
  runAudit: (req: RunAuditRequest) =>
    apiClient.post<{ data: RunAuditResponse }>('/api/c901g/run', req).then(r => r.data.data),
};
